import React from "react";
import {
    FaUserCircle as FaUserCircleIcon,
    FaClipboardList as FaClipboardListIcon,
    FaHeartbeat as FaHeartbeatIcon,
    FaCheckCircle as FaCheckCircleIcon,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import colors from "../../constants/colors";
import { TeleconsultCardProps } from "../interface/consult";

const FaUserCircle = FaUserCircleIcon as any;
const FaClipboardList = FaClipboardListIcon as any;
const FaHeartbeat = FaHeartbeatIcon as any;
const FaCheckCircle = FaCheckCircleIcon as any;

const TeleconsultCardTwo: React.FC<TeleconsultCardProps> = ({
    teleconsultHistory,
    participantName,
}) => {
    const navigate = useNavigate();
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);

    const refNumber =
        teleconsultHistory?.participants?.subscriber?.[0]?.ref_number;
    // console.log("tele", teleconsultHistory);

    const handleNavigate = (section: string) => {
        switch (section) {
            case "Summary":
                const publisherToken =
                    teleconsultHistory?.participants?.publisher?.[0]?.token;
                if (publisherToken) {
                    navigate(
                        `/teleconsultsummary/${publisherToken}`
                    );
                } else {
                    console.error("Publisher token is missing or undefined.");
                }
                break;
            case "Health":
                if (refNumber) {
                    navigate(`/HealthVitals/${refNumber}`);
                } else {
                    console.error("Reference number is missing or undefined.");
                }
                break;
            case "Status":
                const teleconsultId = teleconsultHistory?.id;
                const statusToken =
                    teleconsultHistory?.participants?.publisher?.[0]?.token;
                console.log("teleconsultId", teleconsultId);
                if (teleconsultId && statusToken) {
                    window.dispatchEvent(new CustomEvent('open-in-app-call', {
                        detail: {
                            url: `https://teleconsult.a2zhealth.in/teleconsult-v3/${statusToken}`,
                            patientName: subscriberName,
                            patientId: refNumber
                        }
                    }));
                } else {
                    console.error(
                        "Teleconsult history ID or publisher token is missing or undefined."
                    );
                }
                break;
            default:
                console.error("Invalid section specified.");
                break;
        }
    };

    const handleSnackbarClose = () => setSnackbarOpen(false);

    const consultId = teleconsultHistory?.id || "Unknown ID";
    const subscriberName =
        teleconsultHistory?.participants?.subscriber?.[0]?.participant_info?.name;
    const subscriberPhoneNumber =
        teleconsultHistory?.participants?.subscriber?.[0]?.participant_info?.phone;
    const subscriberEmail =
        teleconsultHistory?.participants?.subscriber?.[0]?.participant_info?.email;
    const subscriberGender =
        teleconsultHistory?.participants?.subscriber?.[0]?.participant_info?.gender;
    const consultNotes =
        teleconsultHistory?.consult_status?.name || "No notes available";

    const getConsultNotesIconColor = (status: string) => {
        switch (status) {
            case "New":
                return "bg-blue-500";
            case "Started":
                return "bg-[#ffae42]";
            case "Ended":
                return "bg-green-500";
            case "Cancelled":
                return "bg-red-500";
            case "Waiting":
                return "bg-yellow-500";
            default:
                return "bg-gray-300";
        }
    };

    return (
        <div className="bg-gradient-to-b from-white to-gray-100 border rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
            {/* Status Indicator */}
            {/* <div
        className={`h-1 w-full ${getConsultNotesIconColor(consultNotes)} rounded-tl-xl rounded-tr-xl`}
      ></div> */}
            {/* Card Content */}


            {/* Card Content */}
            <div className="p-5">
                <div className="flex justify-between items-start">
                    {/* Left Section: Participant Details */}
                    <div className="flex items-center space-x-4">
                        <div className="w-14 h-14 rounded-full bg-gray-300 flex items-center justify-center">
                            <FaUserCircle className="text-gray-700 text-3xl" />
                        </div>
                        <div>
                            <h2 className="font-semibold text-gray-800">
                                <span className="font-medium text-gray-600">
                                    <span className="font-bold">{subscriberName}</span>
                                    {teleconsultHistory?.participants?.subscriber?.[0]?.participant_info?.additional_info?.age || subscriberGender ? (
                                        <>
                                            {/* Conditionally show Age */}
                                            {teleconsultHistory?.participants?.subscriber?.[0]?.participant_info?.additional_info?.age && (
                                                <>
                                                    {" | "}
                                                    <span className="text-sm text-gray-400">
                                                        {teleconsultHistory.participants.subscriber[0].participant_info.additional_info.age} Yrs
                                                    </span>
                                                </>
                                            )}

                                            {/* Conditionally show Gender */}
                                            {subscriberGender && (
                                                <>
                                                    {" | "}
                                                    <span className="text-sm text-gray-400">
                                                        <span className="">{subscriberGender === "Male" ? "M" : "F"}</span>
                                                    </span>
                                                </>
                                            )}
                                        </>
                                    ) : null}
                                </span>
                            </h2>
                            <p className="text-gray-600">
                                <span className="font-small font-semibold">MRN Number:</span>{" "}
                                <span className="text-sm">
                                    {teleconsultHistory?.participants?.subscriber?.[0]?.participant_info?.additional_info?.mrn_number
                                        ? teleconsultHistory.participants.subscriber[0].participant_info.additional_info.mrn_number
                                        : "NA"}
                                </span>
                            </p>

                            <p className="text-gray-600">
                                <span className="font-small font-semibold">Phone:</span>{" "}
                                <span className="text-sm">
                                    {subscriberPhoneNumber ? subscriberPhoneNumber : "NA"}
                                </span>
                            </p>



                            <p className="text-gray-600">
                                <span className="font-small font-semibold">Email:</span>{" "}
                                <span className="text-sm">
                                    {subscriberEmail ? subscriberEmail : "NA"}
                                </span>
                            </p>
                            <p className="text-gray-600">
                                <span className="font-small font-semibold">Reason:</span>{" "}
                                <span className="text-sm">
                                    {teleconsultHistory?.reason || "Not provided"}
                                </span>
                            </p>
                            {/* <p className="text-gray-600">
                <span className="font-small font-semibold">Treatment For:</span>{" "}
                <span className="capitalize text-sm">
                  {
                    teleconsultHistory?.participants?.publisher?.[0]
                      ?.participant_info?.additional_info?.consult_speciality
                  }
                </span>
              </p> */}


                        </div>
                    </div>

                    {/* Right Section: Consult ID with Dynamic Background Color */}
                    <div
                        className={`text-right text-white px-1 rounded-lg ${getConsultNotesIconColor(consultNotes)}`}
                    >
                        {/* <p className="font-medium">Consult ID:</p> */}
                        <p className="font-semibold">{consultId}</p>
                    </div>
                </div>
            </div>


            {/* Action Buttons */}
            <div className="flex divide-x divide-gray-300">
                <button
                    className="flex-1 py-2 text-center text-gray-800 hover:bg-gray-100 transition"
                    onClick={() => handleNavigate("Summary")}
                >
                    <FaClipboardList className="inline-block mr-2" />
                    Summary
                </button>
                {/* <button
                    className="flex-1 py-2 text-center text-gray-800 hover:bg-gray-100 transition"
                    onClick={() => handleNavigate("Health")}
                >
                    <FaHeartbeat className="inline-block mr-2 text-green-600" />
                    Health
                </button> */}
                <button
                    className={`flex-1 text-center rounded-tl-md rounded-bl-md rounded-br-md text-white transition ${getConsultNotesIconColor(consultNotes)}`}
                    onClick={() => handleNavigate("Status")}
                    disabled={
                        teleconsultHistory?.consult_status?.name === "Ended" ||
                        teleconsultHistory?.consult_status?.name === "Cancelled"
                    }
                >
                    <FaCheckCircle className="inline-block mr-2" />
                    {consultNotes}
                </button>
            </div>

            {/* Snackbar */}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
            >
                <Alert onClose={handleSnackbarClose} severity="info" sx={{ width: "100%" }}>
                    Teleconsult status updated!
                </Alert>
            </Snackbar>
        </div>
    );
};

export default TeleconsultCardTwo;

